import Loadable from 'UIComponents/decorators/Loadable';
const AsyncDetailsPanel = Loadable({
  loader: () => import( /* webpackChunkName: "details-panel" */'email-management-lib/refactor/components/manage/frameworkTable/components/DetailsPanel')
});
export default AsyncDetailsPanel;